import { render, staticRenderFns } from "./admin-portal-user-form.vue?vue&type=template&id=123976fa"
import script from "./admin-portal-user-form.vue?vue&type=script&lang=js"
export * from "./admin-portal-user-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports